// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/** Onde a permissão vale. SELF = próprios recursos; HOSPITAL/GROUP/CONVENIO = escopados por id. */
export const scopeSchema = z.enum(['GLOBAL', 'HOSPITAL', 'GROUP', 'SELF', 'CONVENIO'])
export type Scope = z.infer<typeof scopeSchema>
